import { useEffect, useState } from 'react';

/**
 * Reports whether a request has been running long enough to be worth telling
 * the user about.
 *
 * Lander traffic is stored for the busiest landers only. Anything else is
 * looked up in Plausible on demand, which takes about ten seconds, so a spinner
 * alone reads as a page that is broken rather than one that is working.
 */
export function useSlowRequest(loading: boolean, thresholdMs = 1500): boolean {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setSlow(false);
      return;
    }

    const timer = setTimeout(() => setSlow(true), thresholdMs);
    return () => clearTimeout(timer);
  }, [loading, thresholdMs]);

  return slow;
}
